import { render, staticRenderFns } from "./index-new.vue?vue&type=template&id=7548a4a0&scoped=true&"
import script from "./index-new.vue?vue&type=script&lang=js&"
export * from "./index-new.vue?vue&type=script&lang=js&"
import style0 from "./index-new.vue?vue&type=style&index=0&id=7548a4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7548a4a0",
  null
  
)

export default component.exports